import React, { useState } from 'react'
import './Orders.css'
import ProductCatlog from './ProductCatlog';
const SalesReport = () => {
  
  return (
     <>
     <ProductCatlog/>
     </>
  )
}

export default SalesReport